const defaultTheme = {
  global: {
    font: {
      family: "Orbitron",
      // size: "14px",
      // height: "20px",
    },
  },
};

export default defaultTheme;
